import { Box, Checkbox, Text } from '@factorialco/deprecated-design-system'
import { F0TagDot } from '@factorialco/f0-react'
import { AtsQuestionTypeEnum } from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import { getQuestionTagColor, getQuestionTypeLabel } from 'modules/ats/lib/utils/customQuestion'

interface Props {
  label: string
  mandatory: boolean
  autoDisqualify: boolean
  questionType: AtsQuestionTypeEnum
  onChange: () => void
  isSelected: boolean
  id: number
}

const QuestionTemplateCard = ({
  label,
  mandatory,
  autoDisqualify,
  questionType,
  onChange,
  isSelected,
  id,
}: Props) => {
  return (
    <Box
      width="full"
      flexDirection="row"
      gap="s24"
      alignItems="center"
      justifyContent="spaceBetween"
      padding="s16"
      border={{
        all: {
          color: 'grey400',
          width: 's1',
          style: 'solid',
        },
      }}
      borderRadius={{ all: 'abs016' }}
    >
      <Checkbox
        id={label}
        name={label}
        onChange={onChange}
        size="large"
        value={id}
        checked={isSelected}
      />

      <Box gap="s8" flexGrow>
        <Text.Normal size="200" color="black" weight="medium">
          {label}
        </Text.Normal>

        {(mandatory || autoDisqualify) && (
          <Text.Normal size="200" color="grey800" weight="normal" capitalize>
            {i18n.t('common.mandatory')}
            {autoDisqualify && mandatory && ' / '}
            {autoDisqualify &&
              i18n.t('ats.job_posting_settings.application_form.custom_questions.auto_disqualify')}
          </Text.Normal>
        )}
      </Box>
      <F0TagDot
        color={getQuestionTagColor(questionType ?? 'default')}
        text={getQuestionTypeLabel(questionType)}
      />
    </Box>
  )
}

export default QuestionTemplateCard
